export const NO_DATA_AVAILABLE = "No data available for selected date range";
export const URLs = {
  sales: {
    deviceSales: {},
    activationSales: {},
    rechargeSales: {},
  },
  payouts: {
    devicePayout: {},
    rechargePayout: {},
    activationPayout: {},
  },
  earnings: {
    deviceEarning: {},
    rechargeEarning: {},
    activationEarning: {},
  },
};
export const filterNames = {
  region: "Region",
  state: "State",
  zd: "ZD/ZDMT/ARD/MARD",
  rds_chain: "RDS/Chain",
  retail_cat: "Retail Category",
  button: "button",
  jc: "JC",
  rds_ard: "RDS/ARD/MARD",
  scheme_type: "Scheme_Type",
  scheme: "Scheme",
  all_jc_jp: "All/JC/JP",
  all_jp: "All/JP",
  distributor: "Distributors",
  retailer: "Retailers",
  smb: "SMB",
  end: "END",
  fiber: "Fiber",
  jba: "142",
  JBA: "JIO BUSINESS ASSOCIATE",
  JBAP: "JIO BUSINESS ASSOCIATE PARTNER",
  mobility: "Mobility",
  ed1: "wireline jiofiber",
  ed2: "Wireline Enterprise Connectivity",
  performance: "Performance Details",
  enterprisePerf: "Enterprise Connectivity Perf(Installed)",
  acqPerf: "New Acquisition By Product",
  upgradeByProduct: "Upgrade By Product",
  plan: "No. Of Links By Plan",
  End: "ENTERPRISE DISTRIBUTOR",
  xg: "ENTERPRISE DISTRIBUTOR LITE",
  payout: "Payout Dashboard",
  partnerName: [
    "JIO BUSINESS ASSOCIATE PARTNER",
    "ENTERPRISE DISTRIBUTOR",
    "JIO BUSINESS ASSOCIATE",
    "JR. TECHNICIANS TYPE 2",
    "DIRECT LCO",
    "JIOFIBER JC RETAILER",
    "FTTX DISTRIBUTOR",
    "JIOFIBER JC SALES ENTREPRENR",
    "HOME SERVICE PARTNER",
  ],
};

export const entConPerfHeaders = ["Period", "Ach"];
export const newAcqHeaders = ["Product", "# of Links", "OBV(In Lakh)"];
export const upgradeByProductHeaders = ["Product", "OBV(In Lakh)"];

export const schemeCountDashboardNames = [
  "Activation Payout",
  "Device Payout",
  "Recharge Payout",
];
